var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateSettings as updateSettingsService } from '../services/AIInspectionManagerService';
export default function useUpdateAIInspectionManager() {
    const queryClient = useQueryClient();
    const updateSettings = useMutation(({ settingsUpdate }) => updateSettingsService(settingsUpdate), {
        onError: (err, _variables, context) => {
            if (context === null || context === void 0 ? void 0 : context.previousSettings) {
                queryClient.setQueryData(['aiInspectionManagerSettings'], context.previousSettings);
            }
        },
        onMutate: (_a) => __awaiter(this, [_a], void 0, function* ({ settingsUpdate }) {
            yield queryClient.cancelQueries(['aiInspectionManagerSettings']);
            const previousSettings = queryClient.getQueryData(['aiInspectionManagerSettings']);
            queryClient.setQueryData(['aiInspectionManagerSettings'], (old) => (Object.assign(Object.assign({}, old), settingsUpdate)));
            return { previousSettings };
        }),
        onSettled: () => {
            void queryClient.invalidateQueries(['aiInspectionManagerSettings']);
        },
        onSuccess: () => {
            void queryClient.invalidateQueries(['aiInspectionManagerSettings']);
        }
    });
    return { updateSettings };
}
